import React from 'react';
import { Card } from '../components/ui/card';
import { Scale, Users, Trophy, HeartHandshake } from 'lucide-react';

const OverOns = () => {
  return (
    <div>
      <section className="hero-gradient text-white py-16">
        <div className="max-w-4xl mx-auto px-4 md:px-6">
          <h1 className="text-4xl md:text-5xl font-bold uppercase">Over Bezwaarmeesters</h1>
          <p className="text-slate-200 mt-4 text-lg max-w-2xl">Wij zijn een team ervaren juristen dat sinds 2020 duizenden Nederlanders heeft geholpen bij onterechte boetes en beschikkingen.</p>
        </div>
      </section>
      <section className="py-14 max-w-5xl mx-auto px-4 md:px-6">
        <div>
          <h2 className="text-2xl font-bold text-[#1e1b4b] uppercase">Onze missie</h2>
          <div className="w-16 h-0.5 bg-[#f26b1f] mt-2 mb-4" />
          <p className="text-slate-700 mt-3 leading-relaxed">De overheid maakt fouten. Wij zorgen dat jij niet onterecht betaalt. Met onze juridische expertise maken wij bezwaar toegankelijk voor iedereen, zonder kosten vooraf. Winnen we? Jij krijgt het geld terug. Verliezen we? Dan betaal je niets.</p>
          <p className="text-slate-700 mt-3 leading-relaxed">Elk bezwaar is voor ons een meesterzet. Wij combineren jarenlange juridische kennis met heldere, persoonlijke communicatie via e-mail. Zo weet je altijd waar je aan toe bent.</p>
        </div>

        <div className="grid sm:grid-cols-2 md:grid-cols-4 gap-4 mt-14">
          {[[Users,'1500+','Zaken'],[Trophy,'~25%','Winkans'],[Scale,'6 jaar','Ervaring'],[HeartHandshake,'4,2/5','Beoordeling']].map(([I,v,l]) => (
            <Card key={l} className="p-5 text-center border border-slate-200">
              <I className="w-6 h-6 text-[#f26b1f] mx-auto" />
              <div className="text-2xl font-bold text-[#1e1b4b] mt-2">{v}</div>
              <div className="text-xs uppercase text-slate-500 tracking-wider">{l}</div>
            </Card>
          ))}
        </div>

        <div className="mt-14">
          <h2 className="text-2xl font-bold text-[#1e1b4b] uppercase">Ons team</h2>
          <div className="w-16 h-0.5 bg-[#f26b1f] mt-2 mb-4" />
          <div className="grid sm:grid-cols-3 gap-6 mt-6">
            {[
              { name: 'mr. Eva Bakker', role: 'Senior Jurist', bio: 'Ruim 8 jaar ervaring in bestuurs- en verkeersrecht. Specialist in complexe naheffingsaanslagen.' },
              { name: 'mr. Thijs Meijer', role: 'Verkeersrecht Specialist', bio: 'Behandelt jaarlijks honderden CJIB-boetes en flitszaken. Regelmatig te gast bij radio-uitzendingen over verkeersrecht.' },
              { name: 'mr. Lars Hendriks', role: 'Fiscaal Jurist', bio: 'Focus op parkeerbelasting, gemeentelijke heffingen en dwangbevelen. Sluitstuk voor onze zwaardere zaken.' },
            ].map(m => (
              <Card key={m.name} className="p-6 border border-slate-200 card-hover">
                <div className="font-bold text-[#1e1b4b]">{m.name}</div>
                <div className="text-sm text-[#f26b1f] font-medium">{m.role}</div>
                <p className="text-sm text-slate-600 mt-3 leading-relaxed">{m.bio}</p>
              </Card>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default OverOns;
